const KEY = "paws.dev";
const TAPS = 7;
const WINDOW_MS = 2000;

export function createDevMode({ storage = globalThis.localStorage, taps = TAPS, windowMs = WINDOW_MS,
  now = () => Date.now() } = {}) {
  const listeners = new Set();
  let unlocked = false;
  try {
    unlocked = storage?.getItem(KEY) === "1";
  } catch {
    unlocked = false;
  }
  let count = 0;
  let lastTap = 0;

  const persist = () => {
    try {
      if (unlocked) storage?.setItem(KEY, "1");
      else storage?.removeItem(KEY);
    } catch {
      return false;
    }
    return true;
  };

  const announce = () => {
    for (const listener of listeners) listener(unlocked);
  };

  return {
    get enabled() {
      return unlocked;
    },
    get taps() {
      return taps;
    },
    onChange(listener) {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    lock() {
      unlocked = false;
      count = 0;
      persist();
      announce();
      return unlocked;
    },
    tap() {
      const moment = now();
      count = moment - lastTap > windowMs ? 1 : count + 1;
      lastTap = moment;
      if (unlocked) return { unlocked: true, missing: 0, changed: false };
      if (count < taps) return { unlocked: false, missing: taps - count, changed: false };
      unlocked = true;
      count = 0;
      persist();
      announce();
      return { unlocked: true, missing: 0, changed: true };
    }
  };
}
